import { Component, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, finalize, Observable, of, switchMap } from 'rxjs';
import { ShopService } from '../../../shop/services/shop.service';


@Component({
  selector: 'autocomplete',
  imports: [ReactiveFormsModule],
  templateUrl: './autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AutocompleteComponent,
      multi: true
    }
  ]
})
export class AutocompleteComponent implements ControlValueAccessor {

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  shopService = inject(ShopService);

  value: string | null = null;
  searchControl = new FormControl('');

  isLoading = signal<boolean>(false);
  showDropdown = signal<boolean>(false);

  options: any[] = [];

  ngOnInit(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      switchMap(value => this.getOptions(value))
    ).subscribe(res => {
      this.options = res;
      this.showDropdown.set(true);
    });
  }

  selectOption(option: any) {

    this.value = option.id;

    this.showDropdown.set(false);

    this.onChange(this.value);
    this.onTouched();

    this.searchControl.setValue(option.name, { emitEvent: false });
  }

 clearInput(): void {

  this.searchControl.setValue('');
  this.options = [];
  this.showDropdown.set(false);

  setTimeout(() => this.searchInput.nativeElement.focus());
}

  onFocus(): void {

    this.showDropdown.set(true)
    setTimeout(() => {
      this.searchInput.nativeElement.select();
    });
  }

  onBlur(): void {
    setTimeout(() => this.showDropdown.set(false), 200);
  }

  onChange = (val: string | null) => { };
  onTouched = () => { };

  writeValue(val: string): void {
    this.value = val ?? null;
  }

  registerOnChange(fn: (val: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  getOptions(searchText: string | null): Observable<any[]> {

    if (searchText?.length! > 2) {
      this.isLoading.set(true);
      return this.shopService.getCustomerAccounts({ searchText }).pipe(
        finalize(() => this.isLoading.set(false))
      );
    }

    return of([]);
  }
}
